import { useMediaQuery } from '@mantine/hooks'
import { toast, Zoom } from 'react-toastify'

import { useDialog } from './useDialog'

export const useCopyUrlShare = () => {
  const { isDialogOpened, onDialogOpenHandler, onDialogCloseHandler } = useDialog()
  const isMobile = useMediaQuery('(max-width: 767px)')

  const copyUrlShare = async (url: string, position: any = 'top-center') => {
    try {
      if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(url)
      } else {
        const hiddenText = document.createElement('textarea')
        hiddenText.innerText = url
        document.body.appendChild(hiddenText)
        hiddenText.select()
        document.execCommand('copy')
        hiddenText.remove()
      }

      return toast.success(
        <span className="font-bold text-white lg:text-xl">링크가 복사되었습니다.</span>,
        {
          toastId: 'urlCopy',
          position: position,
          className:
            position === 'bottom-center'
              ? 'bottom-30 px-4 py-3 lg:px-6 lg:py-5 rounded-md mx-auto tracking-tight'
              : 'top-6 lg:top-28 px-4 py-3 lg:px-6 lg:py-5 rounded-md mx-auto tracking-tight',
          bodyClassName: 'p-0 flex items-center',
          closeButton: false,
          icon: <img src="/svg/icon_solid_check.svg" width={22} height={22} alt="check icon" />,
          style: {
            backgroundColor: '#393939',
            width: isMobile ? '227px' : '290px',
          },
          transition: Zoom,
        },
      )
    } catch (e) {
      console.error(e)
    } finally {
      onDialogCloseHandler()
    }
  }

  return { copyUrlShare, isDialogOpened, onDialogOpenHandler, onDialogCloseHandler }
}
